import { z } from 'zod';

import { apiClient } from './client';

// Utilities API — meter readings (tenant submission).

export const UtilityTypeZ = z.enum(['electricity', 'water_cold', 'water_hot', 'gas', 'heating']);
export type UtilityType = z.infer<typeof UtilityTypeZ>;

export const ReadingZ = z.object({
  id: z.number().int(),
  lease_id: z.number().int(),
  type: UtilityTypeZ,
  period_month: z.number().int().min(1).max(12),
  period_year: z.number().int(),
  value: z.number(),
  photo_url: z.string().nullable().optional(),
  receipt_url: z.string().nullable().optional(),
  status: z.enum(['pending', 'approved', 'rejected']),
  submitted_at: z.string().optional(),
});
export type Reading = z.infer<typeof ReadingZ>;

const ListReadingsZ = z.object({ data: z.array(ReadingZ) });
const ResourceReadingZ = z.object({ data: ReadingZ });

export async function listReadings(params: { lease_id: number; period_year?: number }): Promise<Reading[]> {
  const res = await apiClient.get('/utilities/readings', { params });
  return ListReadingsZ.parse(res.data).data;
}

export async function submitReading(form: FormData): Promise<Reading> {
  const res = await apiClient.post('/utilities/readings', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return ResourceReadingZ.parse(res.data).data;
}

export const utilitiesApi = { list: listReadings, submit: submitReading };
